import React, { Component } from 'react';
import Link from 'gatsby-link';
import {ListItem, ListItemLeft} from '../static/styles/styles';

const NavItem = ({ item, type }) => {
  const Item = type === 'main' ? ListItem : ListItemLeft;

  return (
    <Link
      activeStyle={{
        fontWeight: 'bold'
      }}
      style={{ color: '#000', textDecoration: 'none' }}
      to={item.to}
    >
      <Item>{item.name}</Item>
    </Link>
  );
};

export default NavItem;



// WEBPACK FOOTER //
// ./src/componenten/NavItem.js